export default __webpack_public_path__ + "static/media/1970.33c4866b.png";